/**
 * Evaluate panel visibility conditions safely.
 * Supports: "selectedRow", "!selectedRow", "form_prefill.id", "panelOutputs.panelId.table_data",
 * "interviewPhaseId", "interviewSession.currentPhaseId", "interviewSession.currentPhase.label"
 */
export function evaluateVisibilityCondition(condition, context) {
  if (!condition || typeof condition !== 'string') return true;
  const trimmed = condition.trim();
  if (!trimmed) return true;

  const negated = trimmed.startsWith('!');
  const path = negated ? trimmed.slice(1).trim() : trimmed;

  const value = getByPath(context, path);
  const result = Boolean(value);
  return negated ? !result : result;
}

function getByPath(obj, path) {
  if (!obj || !path) return undefined;
  const parts = path.split('.');
  let current = obj;
  for (const part of parts) {
    if (current == null) return undefined;
    current = current[part];
  }
  return current;
}
